import React from 'react'

export default function Faqs() {
  return (
    <div>Faqs</div>
  )
}
